import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { map } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { AccessService } from '../services/access.service';

/**
 * Route guard that allows access only to members of the Galaxy-Admins Entra ID group.
 * If the membership check hasn't resolved yet, triggers a backend check before deciding.
 * Non-members are redirected to the root.
 */
export const adminAccessGuard: CanActivateFn = () => {
  const accessService = inject(AccessService);
  const router = inject(Router);
  const messageService = inject(MessageService);

  const currentValue = accessService.isGalaxyAdmin();

  if (currentValue === true) return true;
  if (currentValue === false) {
    messageService.add({ severity: 'warn', summary: 'You do not have access to this page.', life: 6000 });
    return router.createUrlTree(['/']);
  }

  // null = not yet resolved — trigger a check and wait for the result
  return accessService.checkAccess().pipe(
    map(result => {
      if (result.galaxyAdmins === true) return true;
      messageService.add({ severity: 'warn', summary: 'You do not have access to this page.', life: 6000 });
      return router.createUrlTree(['/']);
    })
  );
};
